import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { FeedbackQuestionTitleRenderProps } from './utils';
import { RenderHtml } from 'npo/pages/ReportBuilder/Components/Review/ReportCustomQuestionType/utils';

interface DisplayCommentCountProps {
  total: number;
  className?: string;
  onClick?: () => unknown;
}

export const DisplayCommentCount: React.FC<DisplayCommentCountProps> = ({
  total,
  className,
  onClick,
}) => {
  return (
    <TrueImpactText
      variant="body-small"
      className={className}
      onClick={onClick}
    >
      {total} {total === 1 ? 'Comment' : 'Comments'}
    </TrueImpactText>
  );
};

const StyledDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${COLORS.grayLightest};
  .title {
    flex: 1;
    padding-right: ${SPACERS.tiny};
  }
  .not-allowed {
    color: ${COLORS.critical};
  }
`;

const FeedbackQuestionTitleRender: React.FC<FeedbackQuestionTitleRenderProps> = ({
  title,
  disabled,
  commentsLength,
}) => {
  return (
    <StyledDiv>
      <TrueImpactText variant="body-bold" className="title">
        <RenderHtml text={title} />
      </TrueImpactText>
      {disabled ? (
        <span className="not-allowed">No comments allowed</span>
      ) : (
        <DisplayCommentCount total={commentsLength} />
      )}
    </StyledDiv>
  );
};

export default FeedbackQuestionTitleRender;
